<template>
    <main class="page c-post__page" role="main">
        <div class="post">
            <div class="o-wrapper">
                <article v-if="post" class="post__view post__click o-grid o-grid--center">
                    <header class="o-grid__item u-width-full u-m-t6 u-m-t4@l u-m-t2@m">
                        <div ref="articleHead" class="o-grid--center u-width-5/8 u-width-10/12@l u-width-full@m u-center">
                            <div class="post__details">
                                <div ref="articleTitle" :class="['post__wrap', sticky ? 'scroll' : '']">
                                    <template v-if="post && post.repost_id > 0">
                                        <div ref="communityLogo" class="post__community-img">
                                            <a :href="'/' + post.community_url">
                                                <img
                                                    :src="$simpleStore.transformImageWithCloudfront(64, 64, 'img/communities/' + post.community_id + '/' + post.community_thumbnail, $root)"
                                                    :alt="post.community_name"
                                                >
                                            </a>
                                            <a
                                                v-if="post.source_community_id > 0"
                                                :href="'/' + post.source_community_url"
                                                class="post__community-img-source"
                                            >
                                                <img
                                                    :src="$simpleStore.transformImageWithCloudfront(25, 25, 'img/communities/' + post.source_community_id + '/' + post.source_community_image, $root)"
                                                    :alt="post.source_community_name"
                                                >
                                            </a>
                                        </div>
                                        <div class="post__from">
                                            <div class="post__from-community">
                                                <p>
                                                    <a :href="'/' + post.community_url">{{ post.community_name }}</a>
                                                </p>
                                            </div>
                                            <div class="post__from-details">
                                                <p>Reposted from</p>
                                                <p v-if="post.source_community_id > 0">
                                                    <a :href="'/' + post.source_community_url">{{ post.source_community_name }}</a>
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else-if="post && post.network_id === $simpleStore.Networks.DY">
                                        <div class="post__ugc">
                                            <div class="post__ugc-img">
                                                <a :href="'/u/' + post.username" class="post__ugc-img--user">
                                                    <img
                                                        :src="post.user_avatar"
                                                        :alt="'Article Posted by ' + post.first_name + ' ' + post.surname"
                                                    >
                                                </a>
                                                <a :href="'/' + post.community_url" class="post__ugc-img--community">
                                                    <img
                                                        :src="$simpleStore.transformImageWithCloudfront(25,25,'img/communities/' + post.community_id + '/' + post.community_thumbnail, $root)"
                                                        :alt="post.community_name"
                                                    >
                                                </a>
                                            </div>
                                            <div class="post__ugc-details">
                                                <p class="post__ugc-user">
                                                    <a :href="'/u/' + post.username">
                                                        {{ post.first_name }} {{ post.surname }}
                                                    </a>
                                                    <!-- TODO Show if user is accredited -->
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
                                                        <path d="M13.0678 1.87572L12.6127 2.46668L13.0678 1.87572C12.4384 1.39102 11.5616 1.39102 10.9322 1.87572L9.45555 3.01297L9.81993 3.48609L9.45555 3.01297C9.40604 3.0511 9.34404 3.06931 9.28177 3.064L7.42469 2.90562C6.63319 2.83812 5.89551 3.3122 5.62811 4.06021L5.00072 5.81526C4.97968 5.87411 4.93737 5.92295 4.88211 5.95214L3.23421 6.82292C2.53187 7.19405 2.1676 7.99169 2.34705 8.76553L2.76811 10.5812C2.78223 10.642 2.77303 10.706 2.74233 10.7604L1.82681 12.3839L2.47756 12.7509L1.82681 12.3839C1.43661 13.0758 1.5614 13.9438 2.13074 14.4978L3.46656 15.7975C3.51135 15.8411 3.53819 15.8999 3.5418 15.9623L3.64932 17.823C3.69515 18.6161 4.26939 19.2788 5.04784 19.437L6.87431 19.8082C6.93556 19.8207 6.98992 19.8556 7.02668 19.9061L8.12312 21.4133C8.59042 22.0557 9.43178 22.3028 10.1722 22.015L11.9094 21.3398L11.6378 20.6408L11.9094 21.3398C11.9677 21.3172 12.0323 21.3172 12.0906 21.3398L12.3622 20.6408L12.0906 21.3398L13.8278 22.015C14.5682 22.3028 15.4096 22.0557 15.8769 21.4133L16.9733 19.9061C17.0101 19.8556 17.0644 19.8207 17.1257 19.8082L18.9522 19.437C19.7306 19.2788 20.3048 18.6161 20.3507 17.823L20.4582 15.9623C20.4618 15.8999 20.4887 15.8411 20.5334 15.7975L21.8693 14.4978C22.4386 13.9438 22.5634 13.0758 22.1732 12.3839L21.2577 10.7604C21.227 10.706 21.2178 10.642 21.2319 10.5812L21.6529 8.76553C21.8324 7.99169 21.4681 7.19405 20.7658 6.82292L19.1179 5.95214C19.0626 5.92295 19.0203 5.87411 18.9993 5.81526L18.3719 4.06021C18.1045 3.3122 17.3668 2.83812 16.5753 2.90562L14.7182 3.064C14.656 3.06931 14.594 3.0511 14.5444 3.01297L13.0678 1.87572Z" fill="#DB2848" stroke="white" stroke-width="1.5" />
                                                        <path d="M9 11.7419L11.1538 14L15 9" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                                    </svg>
                                                </p>
                                                <p class="post__ugc-community">
                                                    <span>in </span>
                                                    <a :href="'/' + post.community_url" id="article-community-name">
                                                        {{ post.community_name }}
                                                    </a>
                                                </p>
                                                <p class="post__ugc-date">
                                                    {{ post.birthday_long }}
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div
                                            ref="communityLogo"
                                            class="post__community-img"
                                        >
                                            <a :href="'/' + post.community_url">
                                                <img
                                                    :src="$simpleStore.transformImageWithCloudfront(64,64,'img/communities/' + post.community_id + '/' + post.community_thumbnail, $root)"
                                                    :alt="post.community_name"
                                                >
                                            </a>
                                        </div>
                                        <div class="post__from">
                                            <div class="post__from-community">
                                                <p>
                                                    <a :href="'/' + post.community_url">{{ post.community_name }}</a>
                                                </p>
                                            </div>

                                            <div class="post__from-details">
                                                <p>Posted on</p>
                                                <template v-for="(dupe, index) in post.duplicates">
                                                    <a :href="'/' + post.community_url + '/' + post.dyadey_id + (index > 0 ? '/' + dupe.post_id : '')"
                                                       @click.prevent="post.duplicates.length > 1 ? showNetworkPost($event, index, dupe.network_id, post.dyadey_id, dupe.post_id) : null"
                                                       :class="['post__social', (!$route.params.post_id && index === 0) || $route.params.post_id === dupe.post_id.toString() ? 'active' : '']"
                                                    >
                                                        <img :src="getNetworkIcon(dupe.network_id)" alt="">
                                                    </a>
                                                </template>
                                                <p>
                                                    <time :datetime="postBirthdayDatetime" :title="postBirthdayDatetime">
                                                        {{ postBirthdayWords }}
                                                    </time>
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div :class="['post__menu']" @click="togglePostMenu">
                                    <div class="dots">
                                        <div class="dot"></div>
                                    </div>
                                </div>

                                <Menu
                                    :show-menu="showContextMenu"
                                    close-event="bus-index-post-menu-close"
                                >
                                    <div v-if="post.network_id === $simpleStore.Networks.DY">
                                        <div class="menu__links">
                                            <a href="#">Share</a>
                                            <template v-if="!post.repost_id">
                                                <a href="#0">Flag Content</a>
                                                <a href="#0">Hide User Posts</a>
                                                <a href="#0">Report User</a>
                                            </template>
                                            <CopyLink :link="'/' + post.community_url + '/' + post.dyadey_id" menu-name-event="bus-post-menu-toggle"></CopyLink>
                                            <a v-if="!post.repost_id" href="#">Repost to a community</a>
                                            <a
                                                v-if="post.repost_id > 0 && originalSourceUrl"
                                                :href="originalSourceUrl"
                                                @click="togglePostMenu"
                                            >View original post</a>
                                            <a
                                                v-if="$root.user !== false && post.user_id === $root.user.id"
                                                href="#"
                                                @click.prevent="modalDeletePost(post.post_id)">
                                                Delete Post <em>(admin only)</em>
                                            </a>
                                            <a
                                                v-if="admin"
                                                href="#"
                                                @click.prevent="auditPost"
                                                >Audit Post
                                                <span v-if="auditRequested">Requested<br></span>
                                                <em>(accredited user only)</em></a
                                            >
                                            <a href="#" @click="togglePostMenu">Cancel</a>
                                        </div>
                                    </div>

                                    <div v-else>
                                        <div class="menu__links">
                                            <ShareButtons :community-name="$root.community.name" :title="$root.post.share_post_page_title" :show="showShare"></ShareButtons>
                                            <CopyLink :link="'/' + post.community_url + '/' + post.dyadey_id" menu-name-event="bus-post-menu-toggle"></CopyLink>

<!--                                            <a href="#0">Flag Content</a>-->

                                            <a
                                                v-if="admin"
                                                href="#"
                                                @click.prevent="
                                                    modalDeletePost(
                                                        post.post_id
                                                    )
                                                "
                                                >Delete Post
                                                <em>(accredited user only)</em>
                                            </a>
                                        </div>

                                        <div class="menu__source">
                                            <p><a :href="originalSourceUrl" :target="post.repost_id > 0 ? '_self' : '_blank'" @click="togglePostMenu">View original source</a></p>
                                            <div class="menu__socials">
                                                <div class="menu__social" v-if="post.network_id === $simpleStore.Networks.FB">
                                                    <a :href="post.uri" target="_blank" @click="togglePostMenu"><img
                                                        :src="$cdn('/img2.0/icons/facebook.svg')"
                                                        alt="facebook"
                                                        width="25"
                                                        height="25"
                                                    ></a>
                                                </div>
                                                <div class="menu__social" v-if="post.network_id === $simpleStore.Networks.IN">
                                                    <a v-if="post.source" :href="post.source" target="_blank" @click="togglePostMenu"><img
                                                        :src="$cdn('/img2.0/icons/instagram.svg')"
                                                        alt="instagram"
                                                        width="25"
                                                        height="25"
                                                    ></a>
                                                    <a v-else :href="post.source" target="_blank" @click="togglePostMenu"><img
                                                        :src="$cdn('/img2.0/icons/instagram.svg')"
                                                        alt="instagram"
                                                        width="25"
                                                        height="25"
                                                    ></a>
                                                </div>
                                                <div class="menu__social" v-if="post.network_id === $simpleStore.Networks.YT">
                                                    <a :href="post.uri" target="_blank" @click="togglePostMenu"><img
                                                        :src="$cdn('/img2.0/icons/youtube.svg')"
                                                        alt="facebook"
                                                        width="25"
                                                        height="25"
                                                    ></a>
                                                </div>
                                                <div class="menu__social" v-if="post.network_id === $simpleStore.Networks.TW">
                                                    <a :href="post.uri" target="_blank" @click="togglePostMenu"><img
                                                        :src="$cdn('/img2.0/icons/twitter.svg')"
                                                        alt="facebook"
                                                        width="25"
                                                        height="25"
                                                    ></a>
                                                </div>
                                                <template v-for="dupe in post.children">
                                                    <div class="menu__social" v-if="dupe.network_id === $simpleStore.Networks.FB">
                                                        <a :href="dupe.uri" target="_blank" @click="togglePostMenu"><img
                                                            :src="$cdn('/img2.0/icons/facebook.svg')"
                                                            alt="facebook"
                                                            width="25"
                                                            height="25"
                                                        ></a>
                                                    </div>
                                                    <div class="menu__social" v-if="dupe.network_id === $simpleStore.Networks.IN">
                                                        <a :href="dupe.source" target="_blank" @click="togglePostMenu"><img
                                                            :src="$cdn('/img2.0/icons/instagram.svg')"
                                                            alt="instagram"
                                                            width="25"
                                                            height="25"
                                                        ></a>
                                                    </div>
                                                    <div class="menu__social" v-if="dupe.network_id === $simpleStore.Networks.YT">
                                                        <a :href="dupe.uri" target="_blank" @click="togglePostMenu"><img
                                                            :src="$cdn('/img2.0/icons/youtube.svg')"
                                                            alt="facebook"
                                                            width="25"
                                                            height="25"
                                                        ></a>
                                                    </div>
                                                    <div class="menu__social" v-if="dupe.network_id === $simpleStore.Networks.TW">
                                                        <a :href="dupe.uri" target="_blank" @click="togglePostMenu"><img
                                                            :src="$cdn('/img2.0/icons/twitter.svg')"
                                                            alt="facebook"
                                                            width="25"
                                                            height="25"
                                                        ></a>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </Menu>
                            </div>
                            <div class="post__stats">
                                <like-repost-comment></like-repost-comment>
                            </div>
                            <div>
                                <div class="post__title">
                                    <h1 v-html="postTitle"></h1>
                                    <own-the-look v-if="$root.brand.key === 'klektive' && otlEnabled"></own-the-look>
                                </div>
                                <!--                            <div class="c-article__posted c-article__posted&#45;&#45;reposted">
                                <div class="c-article__posted-by">
                                    <div>
                                        <img :src="$cdn('/img/user/article.png')" alt="Article Posted by">
                                        <p><span>Harry Smith and 67 others</span> reposted to</p>
                                    </div>

                                    <div>
                                        <img :src="$cdn('/img/article-game-of-thrones.png')" class="article-img"
                                             alt="Game of Thrones Article">
                                        <p>Game of Thrones</p>
                                    </div>
                                </div>
                            </div>-->
                            </div>
                        </div>
                    </header>

                    <router-view></router-view>

                    <a v-if="$root.user !== false"
                        :href="'/post/create/' + post.community_url"
                        class="c-article__add"></a>
                    <a v-else @click.prevent="showMemberPanel()" class="c-article__add"></a>
                </article>
            </div>
        </div>

        <modal></modal>

        <transition name="fade">
            <div v-if="showDeleteModal" class="menu delete-post">
                <div class="o-grid o-grid--center u-bg-white">
                    <div class="o-grid__item u-width-full u-a-center u-p-y6 u-p-x6">
                        <template v-if="showDeleteDraft === false">
                            <h4 class="u-color-blue u-text-24 u-semibold u-m-b2">
                                Delete Post
                            </h4>
                            <p class="u-m-b3">
                                Are you sure you want to delete this post?
                            </p>
                        </template>
                        <template v-else>
                            <h4 class="u-color-blue u-text-24 u-semibold u-m-b2">
                                Delete Draft
                            </h4>
                            <p class="u-m-b3">
                                Are you sure you want to delete this post?
                            </p>
                        </template>
                        <div class="u-flex u-flex-justify-center">
                            <button v-if="$root.user !== false && post.user_id === $root.user.id"
                                class="c-btn c-btn--red u-m-r3"
                                @click="deletePost()"
                            >
                                Yes delete my {{ item }}
                            </button>
                            <button v-else-if="admin === true"
                                class="c-btn c-btn--red u-m-r3"
                                @click="deleteCommunityPost()"
                            >
                                Yes delete community post
                            </button>
                            <button class="c-btn c-btn--red is-outline"
                                @click="closeModal"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-if="admin && showAuditPost" class="menu audit-post">
                <div class="o-grid o-grid--center u-bg-white">
                    <div class="o-grid__item u-width-full u-a-center u-p-y6 u-p-x6">
                        <h4 class="u-color-blue u-text-24 u-semibold u-m-b2">
                            Audit Post <span v-if="auditRequested">Requested</span>
                        </h4>
                        <p class="u-m-b3">
                            Classify post as appropriate below:
                        </p>
                        <div class="u-flex u-flex-justify-center">
                            <button class="c-btn c-btn--red u-m-r3"
                                @click="classifyPost('very good')"
                            >
                                Very Good
                            </button>
                            <button class="c-btn c-btn--red u-m-r3"
                                @click="classifyPost('average')"
                            >
                                Average
                            </button>
                            <button class="c-btn c-btn--red u-m-r3"
                                @click="classifyPost('bad')"
                            >
                                Bad
                            </button>
                            <button class="c-btn c-btn--red u-m-r3"
                                @click="classifyPost('inappropriate')"
                            >
                                Inappropriate
                            </button>
                            <button class="c-btn c-btn--red is-outline"
                                @click="closeModal"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <related-content></related-content>
    </main>
</template>

<script>
import Modal from "../Modal";
import Menu from "../menu/Menu";
import RelatedContent from "./RelatedContent";
import LikeRepostComment from "./LikeRepostComment";
import ShareButtons from "./ShareButtons";
import CopyLink from "../CopyLink";
import OwnTheLook from "./OwnTheLook";
import {forEach} from "vue-slick-carousel/dist/vue-slick-carousel.common";

export default {
    components: {
        Modal,
        Menu,
        RelatedContent,
        LikeRepostComment,
        ShareButtons,
        CopyLink,
        OwnTheLook
    },
    data() {
        const post = this.$root.post || null;
        return {
            // Own the look demo toggle: only shown with ?otl=1 in the URL
            otlEnabled: new URLSearchParams(window.location.search).get('otl') === '1',
            activeNetwork: null,
            auditRequested: this.$root.auditRequested,
            loading: false,
            post: post,
            postBirthdayWords: post?.birthday_long ?? null,
            postBirthdayDatetime: post?.birthday_short ?? null,
            postTitle: post?.post_page_title ?? null,
            headHeight: 0,
            showAuditPost: false,
            showContextMenu: false,
            showDeleteModal: false,
            showDeleteDraft: false,
            sticky: false,
            showShare: false
        };
    },
    created() {
        this.$root.$on(
            'bus-update-post-data',
            (postBirthdayDatetime, postBirthdayWords, postTitle) => {
                this.postBirthdayDatetime = postBirthdayDatetime;
                this.postBirthdayWords = postBirthdayWords;
                this.postTitle = postTitle;
            }
        );
        this.$root.$on('bus-network-post-loaded', () => {
            this.networkPostLoaded();
        });
        this.$root.$on('bus-index-post-menu-close', () => {
            this.showShare = false;
            this.togglePostMenu();
        });
        this.$root.$on('bus-index-post-menu-share', () => {
            this.showShare = true;
            this.togglePostMenu();
        });
    },
    mounted() {
        window.addEventListener('scroll', this.monitorScroll);
        this.headHeight = this.$refs.articleHead ? this.$refs.articleHead.clientHeight : 0;
        // full width image
        if (
            this.post &&
            this.post.network_id === this.$simpleStore.Networks.DY &&
            this.post.thumbnail
        ) {
            // remove images from the content so it is not displayed twice for UGC
            /*let figure = document.querySelector('#content figure.image');
            let fullWidth = false;
            // if class on image is only 'image' then must be full width
            if (figure != null && figure.classList.length === 1 && figure.classList[0] === 'image') {
                fullWidth = true;
            }
            this.post.content = this.post.content.replace(/<figure.+?class='.*?image.*?'.*?>.+<\/figure>/, '');
            if (fullWidth === true) {
                let thumb = document.getElementById('thumbnail');
                thumb.classList.add('u-absolute-full-width');
                let fullWidthImage = document.querySelector('#thumbnail img');
                setTimeout(() => {
                    console.log('fullWidthImage.offsetHeight', fullWidthImage.offsetHeight);
                    let wrapperHeight = fullWidthImage.offsetHeight;
                    // wrap thumb in a static div
                    let parent = thumb.parentNode;
                    let wrapper = document.createElement('div');
                    wrapper.style.position = 'static';
                    wrapper.style.height = wrapperHeight + 'px';
                    parent.replaceChild(wrapper, thumb);
                    wrapper.appendChild(thumb);
                }, 100);
            }*/
        }
    },
    destroy() {
        window.removeEventListener('scroll', this.monitorScroll);
    },
    computed: {
        player() {
            return this.$refs.youtube.player;
        },
        admin() {
            return this.$root.$children[0].admin;
        },
        originalSourceUrl() {
            if (this.post && this.post.repost_id > 0 && this.post.source_community_url && this.post.source_dyadey_id) {
                return '/' + this.post.source_community_url + '/' + this.post.source_dyadey_id;
            }
            return this.post ? this.post.uri : null;
        },
    },
    methods: {
        togglePostMenu(close = false) {
            console.log('this.$root.$children[0]', this.$root.$children[0]);
            if (close === true) {
                this.showContextMenu = false;
            } else {
                this.showContextMenu = !this.showContextMenu;
            }
        },
        monitorScroll() {
            if (typeof this.$refs.articleTitle == 'undefined') {
                return;
            }
            let mediaSize = this.$simpleStore.getMediaSize();
            // don't use sticky for s and xs breakpoints
            if (['xs', 's'].includes(this.$simpleStore.getMediaSize())) {
                return;
            }
            this.scrollPosition = window.scrollY;
            if (typeof this.$refs.communityLogo != 'undefined' && this.scrollPosition >
                this.$parent.$refs.pageHead.clientHeight + this.$refs.communityLogo.clientHeight
            ) {
                this.sticky = true;
                this.$refs.articleHead.style.height = this.headHeight + 'px';
            } else {
                this.sticky = false;
                this.$refs.articleHead.style.height = 'auto';
            }
        },
        playing() {
            //console.log('\o/ we are watching!!!');
        },
        showMemberPanel() {
            this.$simpleStore.showMemberPanel(this);
        },
        modalDeletePost(postId) {
            this.item = 'post';
            this.showDeleteDraft = false;
            this.showDeleteModal = true;
            // hide context menu without unfading background
            this.showContextMenu = false;
            this.$simpleStore.showContextMenu = false;
        },
        closeModal() {
            this.showAuditPost = false;
            this.showDeleteModal = false;
            this.showContextMenu = false;
        },
        deleteCommunityPost() {
            if (this.admin !== true) {
                return;
            }
            this.$http
                .post('/post/admindelete', { post_id: this.post.post_id })
                .then(
                    (response) => {
                        if (response.data.error === false) {
                            sessionStorage.removeItem(
                                'c' + this.post.community_id
                            );
                            window.location = '/' + this.post.community_url;
                        }
                    },
                    (response) => {
                        console.log('Errored:');
                        console.log(response);
                    }
                );
        },
        deletePost() {
            this.$http
                .post('/post/deletemine', { post_id: this.post.post_id })
                .then(
                    (response) => {
                        if (response.data.error === false) {
                            sessionStorage.removeItem(
                                'c' + this.post.community_id
                            );
                            window.location = '/' + this.post.community_url;
                        }
                    },
                    (response) => {
                        console.log('Errored:');
                        console.log(response);
                    }
                );
        },
        auditPost() {
            this.showAuditPost = true;
            this.showContextMenu = false;
        },
        classifyPost(classification) {
            this.$http
                .post('/api/v1/post/audit', {
                    auditRequested: this.auditRequested,
                    post_id: this.post.post_id,
                    classification: classification,
                })
                .then(
                    (response) => {
                        if (response.data.error === false) {
                            sessionStorage.removeItem(
                                'c' + this.post.community_id
                            );
                            let message = 'Post classified as ' + classification;
                            switch (classification) {
                                case 'very good':
                                    message += '\nThis post will now be promoted in this community';
                                    break;

                                case 'average':
                                    message += '\nThis post will not be promoted in this community';
                                    break;

                                case 'bad':
                                    message += '\nThis post will be demoted in this community';
                                    break;

                                case 'inappropriate':
                                    message += '\nThis post will not be published in this community';
                                    break;
                            }
                            window.alert(message);
                            window.location = '/' + this.post.community_url;
                        }
                    },
                    (response) => {
                        console.log('Errored:');
                        console.log(response);
                    }
                );
        },
        showNetworkPost(event, index, networkId, dyadeyId, postId) {
            // remove any existing loading animation
            let socialLinks = document.querySelectorAll('.post__social');
            socialLinks.forEach((currentElement) => {
                currentElement.classList.remove('loading', 'active');
            });
            // add loading animation to clicked element
            event.target.parentElement.classList.add('loading', 'active');
            // only add postId to URL if not first link
            let url = '/' + this.post.community_url + '/' + dyadeyId + (index > 0 ? '/' + postId : '');
            history.pushState({}, '', url);
            this.$root.$emit('bus-load-post', dyadeyId, postId, networkId);
        },
        networkPostLoaded() {
            let socialLinks = document.querySelectorAll('.post__social');
            socialLinks.forEach((currentElement) => {
                currentElement.classList.remove('loading');
            });
        },
        getNetworkIcon(networkId) {
            return this.$cdn('/img2.0/icons/' + this.$simpleStore.NetworkNames[networkId] + '.svg');
        }
    },
};
</script>
